import router from '../../router'

export interface State {
  forms: {
    did_agree_privacy_policy_eula: boolean
    email: string
    password: string
  }
  isRegistrationLoading: boolean
}

export interface Context {
  commit: (name: string, payload: object) => void
  dispatch: (name: string, payload?: any, options?: any) => void
}

export interface Mutations {
  [key: string]: (state: State, payload?: any) => void
}

export interface Actions {
  [key: string]: (this: any, context: Context, payload?: any) => void
}

export const initialState: State = {
  forms: {
    did_agree_privacy_policy_eula: false,
    email: '',
    password: ''
  },
  isRegistrationLoading: false
}

export const mutations: Mutations = {
  setFormData(state, payload) {
    state.forms = { ...state.forms, ...payload }
  },
  onLoadingStart(state) {
    state.isRegistrationLoading = true
  },
  onLoadingFinished(state) {
    state.isRegistrationLoading = false
  }
}

export const actions: Actions = {
  async setFormData({ commit }, payload) {
    commit('setFormData', payload)
  },
  async postSignUp({ commit }, payload) {
    commit('onLoadingStart', {})
    const { error } = await this.$api.postSignUp(this.state.registration.forms)
    if (error) {
      commit('onLoadingFinished', {})
      return
    }
    router.push('/registration/profile/complete')
    commit('onLoadingFinished', {})
  }
}

export default {
  namespaced: true,
  state: () => initialState,
  mutations,
  actions
}
